import { render, staticRenderFns } from "./ChoiceUserDetailItem.vue?vue&type=template&id=4ea6fb74&scoped=true&"
import script from "./ChoiceUserDetailItem.vue?vue&type=script&lang=js&"
export * from "./ChoiceUserDetailItem.vue?vue&type=script&lang=js&"
import style0 from "./ChoiceUserDetailItem.vue?vue&type=style&index=0&id=4ea6fb74&prod&lang=scss&scoped=true&"
import style1 from "./ChoiceUserDetailItem.vue?vue&type=style&index=1&id=4ea6fb74&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../../bankari hypo/BankariBroker/frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ea6fb74",
  null
  
)

export default component.exports